export enum UserIdentityFormFields {
  TaxId = 'tax_id',
  Name = 'name',
  BirthDate = 'birth_date',
}
